import styled, { css } from 'styled-components';
import { Card as AntCard, type CardProps as AntCardProps } from 'antd';
import { type Elevation, getElevation } from 'components/enmon/shared/elevation';
import type { FC } from 'react';

interface CardProps extends AntCardProps {
  $sameHeight?: boolean;
  $elevation?: Elevation;
}

const StyledCard = styled(AntCard)<CardProps>`
  .ant-card-head {
    border-bottom: none;
    font-size: 1.2rem;
    margin-bottom: 0;

    &-title {
      padding-bottom: 0;
    }
  }

  .ant-card-actions {
    border-top: none;
  }

  ${getElevation}

  // NOTE: if true, the card will be the same height as the parent
  ${({ $sameHeight }) =>
    $sameHeight &&
    css`
      display: flex;
      flex-direction: column;
      height: 100%;

      // NOTE: Sets card body height to 100% to position actions container at the bottom of the card
      & .ant-card-body {
        display: flex;

        height: 100%;
      }
    `}
`;

export const Card: FC<CardProps> = props => <StyledCard variant="borderless" {...props} />;
